import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetConstantCategoryListPagingAndFilterRequest } from '../../../../models/request/constantCategory/GetConstantCategoryListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetConstantCategoryListPagingAndFilterRequest
    setFilter: React.Dispatch<React.SetStateAction<GetConstantCategoryListPagingAndFilterRequest>>
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const ConstantCategoryListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    setFilter,
    selectedCount,
    deleteFunction,
    updateFunction,
    onSearchSubmit
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            {/* Arama kutusu ve Güncelle / Sil düğmeleri üst şeritte (standart). */}
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/constantcategory/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Sabit Tanımlama Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default ConstantCategoryListFilters;